import { useMemo } from 'react';

import { useIntl } from 'react-intl-next';

import type { UserConvoAIStreamingConfig } from '@atlassian/ai-agent-streaming';
import type { AiFeatureRequestEnvelopeConfluenceQuickSummaryRequest } from '@atlassian/convo-ai-api';

export const useAISummaryRequestConfig = (ari: string) => {
	const { locale } = useIntl();

	return useMemo<
		[AiFeatureRequestEnvelopeConfluenceQuickSummaryRequest, UserConvoAIStreamingConfig]
	>(
		() => [
			{
				ai_feature_input: {
					content_ari: ari,
					locale,
					summary_output_mimetype: 'text/markdown-plus',
				},
			},
			{
				apiPath: 'v2/ai-feature/confluence-quick-summary',
				delayChunkUpdate: { gap: 10, time: 20 },
				headers: {
					'x-experience-id': 'page-summaries',
					'x-product': 'confluence',
				},
			},
		],
		[ari, locale],
	);
};
